import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

class TabButton extends Component {
    onClick = (e) => {
        if (!this.props.isEnabled) {
            e.preventDefault();
        }
    }
    getSeperator = (flag) => {
        return flag ? <div style={{
            width: '1px',
        }} ></div> : null;
    }

    render() {
        const {
            enabledColor,
            disabledColor,
            isSelected,
            showLeftSeparator,
            showRightSeparator,
            onClick,
            className,
            children,
            to,
            isEnabled
        } = this.props;

        const initalStyle = {
            borderBottom: isSelected ? `4px solid ${enabledColor}` : null,
            color: isSelected ? enabledColor : disabledColor,
            padding: '13px 25px',
            boxSizing: 'border-box',
            cursor: isEnabled ? 'pointer' : null,
            pointerEvents: isEnabled ? null : 'none'
        };

        const finalStyle = {
            ...initalStyle,
        };

        return (<Link to={to ? to : '#'} onClick={this.onClick} className={className} style={finalStyle}>
            {this.getSeperator(showLeftSeparator)}
            {children}
            {this.getSeperator(showRightSeparator)}
        </Link>);
    }
}

TabButton.propTypes = {
    isSelected: PropTypes.bool,
    isEnabled: PropTypes.bool,
    showRightSeparator: PropTypes.bool,
    showLeftSeparator: PropTypes.bool,
    onClick: PropTypes.func,
    styles: PropTypes.object
};

TabButton.defaultProps = {
    isSelected: false,
    isEnabled: true,
    showRightSeparator: false,
    showLeftSeparator: false,
    enabledColor: '#534d9a',
    disabledColor: '#666574'
};

export default TabButton;



// WEBPACK FOOTER //
// /src/components/UiComponents/TabButton/TabButton.js